import React from 'react';

const renderAvatarSVG = () => {
    return (
        <svg
            fill="none"
            height="40"
            viewBox="0 0 40 40"
            width="40"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_10877_58906)">
                <rect width="40" height="40" fill="white" />
                <path
                    d="M2655.97 1057.92L2057.33 379.103C1974.04 358.083 1855.23 342.077 1768.36 386.995C1562.46 493.432 1477.8 775.773 1221.78 809.817C1021.37 836.472 989.753 682.586 779.595 788.994C548.347 906.028 635.71 1038.26 388.719 1188.91C141.728 1339.56 56.6274 1011.8 -190.072 1158.21C-252.53 1195.35 -301.639 1253.8 -340.231 1320.53L840.276 2659.15L2655.97 1057.92Z"
                    fill="url(#paint0_linear_10877_58906)"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M439.737 116.96C511.511 272.122 425.49 442.871 300.446 558.684C185.56 665.091 21.4207 705.627 -117.844 633.385C-261.418 558.908 -339.193 399.814 -313.765 240.07C-287.201 73.1916 -168.35 -67.7567 -1.90678 -94.951C175.938 -124.008 363.851 -47.093 439.737 116.96Z"
                    fill="#21BF96"
                />
                <g opacity="0.6" filter="url(#filter0_f_10877_58906)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M177.359 394.15C264.368 312.52 332.423 143.281 391.099 155.128C445.008 166.014 402.95 286.025 358.726 367.158C313.132 450.802 223.772 536.204 137.68 579.776C47.742 625.295 -116.532 625.735 -125.499 567.1C-135.08 504.447 85.365 480.457 177.359 394.15Z"
                        fill="url(#paint1_radial_10877_58906)"
                    />
                </g>
                <g filter="url(#filter1_d_10877_58906)">
                    <path
                        d="M41.5756 40.4351C41.5141 39.8975 41.3817 32.4488 40.4484 27.2467C40.4484 27.2467 53.821 28.186 54.7487 27.7444C55.0811 27.5837 56.6429 26.0358 58.5677 24.1074C61.8308 20.8758 66.1678 16.5713 67.6046 16.1229C69.8984 15.3833 71.1984 14.878 72.6334 15.572C74.0684 16.266 74.9137 16.8282 74.0474 17.8074C73.0553 18.9364 71.0015 18.2202 71.0015 18.2202C71.0015 18.2202 70.6387 19.6055 69.1798 22.6828C69.1798 22.6828 64.0753 33.8454 57.1038 37.6459C55.1911 38.6936 41.5756 40.4351 41.5756 40.4351Z"
                        fill="white"
                    />
                    <path
                        d="M-0.986503 43.669C-0.986503 43.669 3.8564 49.2966 7.91557 50.2329L8.27048 49.4256C8.27048 49.4256 9.31383 65.7372 12.5173 73.9434C13.0355 75.2856 39.3018 69.8623 41.5502 67.4015C41.5502 67.4015 37.7196 47.6658 36.9513 41.4612L42.0353 40.8835C42.0353 40.8835 42.1205 29.5839 40.4329 27.2346C40.4329 27.2346 28.4281 25.8873 22.0257 28.319C15.6233 30.7507 8.33864 31.2984 3.60985 36.0929C-0.49119 40.249 -0.986503 43.669 -0.986503 43.669Z"
                        fill="#041836"
                    />
                    <path
                        d="M42.0356 40.9101L36.9516 41.4877L36.191 39.7568L42.0356 40.9101Z"
                        fill="#041836"
                    />
                    <path
                        d="M23.2713 12.7689C24.3024 14.8339 27.2744 20.8483 26.1859 22.9945C25.0974 25.1407 22.7183 26.0994 22.7183 26.0994L21.8438 28.689C22.2184 29.4649 21.3266 31.311 19.6239 33.1047C18.3677 34.4365 15.9175 33.536 15.1141 31.9283C14.7526 31.1939 12.7221 27.7663 12.7221 27.7663C12.7221 27.7663 9.08349 21.2061 9.33543 18.8695C9.58737 16.533 9.78318 14.2782 14.5973 12.3066C21.9843 9.29647 23.2713 12.7689 23.2713 12.7689Z"
                        fill="white"
                    />
                    <path
                        d="M12.9772 23.2278C13.6899 24.435 14.5718 27.3514 13.5774 27.6407C12.583 27.93 11.4777 27.268 10.2826 25.1182C9.08758 22.9683 5.69286 18.6962 6.33899 16.7091C6.98511 14.722 8.34359 14.9745 8.34359 14.9745C8.34359 14.9745 5.00401 12.7129 6.33897 10.6526C6.33897 10.6526 6.66675 9.81739 8.31551 11.9872C8.31551 11.9872 7.23424 9.56359 9.59795 7.72377C11.9617 5.88396 15.6038 8.14973 15.6038 8.14973C15.6038 8.14973 14.9703 7.19132 15.9462 6.24108C16.9221 5.29083 19.7834 5.30229 20.9814 7.23193C20.9814 7.23193 22.7033 4.03441 25.9543 4.72565C29.2052 5.4169 31.1543 7.75596 28.8031 11.702C26.3393 15.8392 22.5957 11.934 21.6054 11.9205C20.6151 11.907 19.5016 11.8505 18.3117 14.3671C17.1219 16.8836 13.1897 16.7199 13.1897 16.7199C13.1897 16.7199 15.2978 19.5016 15.2078 20.051C15.1178 20.6003 14.8028 21.5045 13.8166 20.1834C12.8303 18.8623 13.1476 18.7978 12.7376 18.5995C12.3276 18.4012 10.8482 17.9406 10.5743 19.8639C10.27 22.0071 12.9772 23.2278 12.9772 23.2278Z"
                        fill="#041836"
                    />
                    <path
                        d="M13.9268 23.1445C12.5774 23.2362 11.0034 22.6504 10.587 20.9104C10.1705 19.1704 11.0943 17.9992 11.822 18.1055C12.5496 18.2118 13.3534 18.7871 13.8471 19.9087"
                        stroke="#041836"
                        strokeWidth="2.1688"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8.34365 14.9752C8.34365 14.9752 6.54126 13.9871 4.87842 14.873"
                        stroke="#041836"
                        strokeWidth="2.1688"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M11.9285 73.7021L6.29912 36.5714"
                        stroke="#041836"
                        strokeWidth="2.1688"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M14.248 31.8201C14.4094 33.1025 17.2106 36.513 20.0072 34.1973C22.8039 31.8817 23.3505 29.1224 23.3505 29.1224"
                        stroke="#041836"
                        strokeWidth="2.1688"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12.9428 91.8226L12.9443 71.0192C12.9443 71.0192 11.1314 46.8785 11.3347 43.7516L11.6749 33.5597"
                        stroke="#041836"
                        strokeWidth="2.1688"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M39.0663 26.6921C41.1035 29.6242 40.6686 40.3409 40.6686 40.3409"
                        stroke="#041836"
                        strokeWidth="2.1688"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M21.8292 28.7024L22.7036 26.1127C22.7036 26.1127 21.1097 26.9857 19.8753 26.7212C19.258 26.5889 18.8624 27.3543 19.3101 27.8146C19.7853 28.2753 20.5642 28.6576 21.8292 28.7024Z"
                        fill="#041836"
                    />
                    <path
                        d="M18.7236 18.4468C18.8152 18.7922 19.0598 19.0158 19.2806 18.9637C19.5014 18.9117 19.6159 18.5829 19.5243 18.2375C19.4328 17.8921 19.1882 17.6686 18.9674 17.7206C18.7466 17.7727 18.6456 18.1154 18.7236 18.4468Z"
                        fill="#041836"
                    />
                    <path
                        d="M22.5884 17.4805C22.68 17.8259 22.9246 18.0495 23.1454 17.9974C23.3662 17.9454 23.4807 17.6166 23.3892 17.2712C23.2976 16.9258 23.053 16.7023 22.8322 16.7543C22.6114 16.8064 22.4968 17.1352 22.5884 17.4805Z"
                        fill="#041836"
                    />
                    <path
                        d="M21.3989 17.9601C21.3989 17.9601 22.6816 19.7257 23.7722 20.4563C23.3084 21.1794 22.2216 21.1784 22.2216 21.1784L21.3989 17.9601Z"
                        fill="#21BF96"
                    />
                    <path
                        d="M20.6904 22.479C20.9244 22.4684 21.1999 22.4447 21.4621 22.3794C21.5175 22.3527 21.5593 22.3119 21.5326 22.2565C21.5058 22.2011 21.4651 22.1592 21.4097 22.186C19.9051 22.5647 18.954 21.6983 18.9404 21.6844C18.8997 21.6425 18.8308 21.6554 18.7889 21.6961C18.7471 21.7368 18.7599 21.8058 18.8006 21.8476C18.8417 21.862 19.5347 22.4908 20.6904 22.479Z"
                        fill="#041836"
                    />
                    <path
                        d="M17.2094 17.5042C17.2919 17.5053 17.3612 17.4649 17.3899 17.3827C17.7591 16.5343 18.4901 16.3929 18.5041 16.3793C18.6145 16.3533 18.6846 16.2579 18.6725 16.1338C18.6465 16.0233 18.5512 15.9532 18.4272 15.9653C18.3857 15.9785 17.4478 16.1584 17.007 17.2123C16.9644 17.3081 17.0175 17.4465 17.1133 17.4891C17.1543 17.5034 17.1819 17.5038 17.2094 17.5042Z"
                        fill="#041836"
                    />
                    <path
                        d="M23.8919 15.7228C23.9469 15.7235 23.9883 15.7103 24.0302 15.6696C24.1138 15.5882 24.1292 15.4645 24.0478 15.3808C23.3032 14.5035 22.3525 14.6144 22.325 14.6141C22.201 14.6261 22.1309 14.7215 22.143 14.8456C22.1551 14.9696 22.2644 15.0262 22.3744 15.0277C22.4158 15.0145 23.1457 14.9556 23.7415 15.6519C23.7683 15.7073 23.8369 15.722 23.8919 15.7228Z"
                        fill="#041836"
                    />
                </g>
                <path
                    d="M-1.07651 45.8184C-0.633859 49.0539 4.02847 57.6014 13.4115 60.397C19.1449 62.1096 26.8011 61.8608 36.868 56.6284C37.1865 56.4506 40.9735 54.7479 41.8552 53.1975C42.7068 51.7242 39.349 53.239 39.7547 52.9974C40.3012 52.6686 41.1528 52.219 41.6557 51.8197C42.4352 51.1905 43.2131 50.1334 42.3011 49.9185C41.3891 49.7035 39.535 50.7839 39.535 50.7839C39.535 50.7839 42.5794 48.8882 41.9088 48.0557C41.2382 47.2232 38.1201 48.921 38.1201 48.921C38.1201 48.921 41.6506 46.646 40.4637 46.0652C39.783 45.7362 38.4335 46.4357 37.54 46.8333C36.1821 47.4406 34.8141 48.3465 33.8385 48.8632C33.8385 48.8632 35.9457 45.8614 34.9449 45.6918C33.944 45.5221 30.9232 49.1094 30.3147 49.7789C29.6894 50.4685 18.0785 52.4166 13.77 47.9689C9.46146 43.5211 9.23008 41.9973 7.76487 41.4232C6.2829 40.8691 -1.72874 41.0944 -1.07651 45.8184Z"
                    fill="white"
                    stroke="#041836"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M3.63442 55.7202C3.63442 55.7202 9.651 50.5207 13.8336 48.0562C13.8336 48.0562 8.48903 41.0038 7.82001 35.0715C6.69849 35.4154 3.35568 34.4348 0.0431878 40.3379C-1.71699 43.4757 -3.71183 48.5333 3.63442 55.7202Z"
                    fill="#041836"
                />
            </g>
            <defs>
                <filter
                    id="filter0_f_10877_58906"
                    x="-245.802"
                    y="34.5374"
                    width="782.296"
                    height="698.094"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="60"
                        result="effect1_foregroundBlur_10877_58906"
                    />
                </filter>
                <filter
                    id="filter1_d_10877_58906"
                    x="-91.406"
                    y="-85.3722"
                    width="277.847"
                    height="321.256"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="10" dy="10" />
                    <feGaussianBlur stdDeviation="50" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0159375 0 0 0 0 0.0945625 0 0 0 0 0.2125 0 0 0 0.2 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_10877_58906"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_10877_58906"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_10877_58906"
                    x1="1748.12"
                    y1="1858.54"
                    x2="548.994"
                    y2="498.799"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#21BF96" />
                    <stop offset="0.9999" stopColor="#DAFF51" />
                    <stop offset="1" stopColor="#DAFF51" />
                </linearGradient>
                <radialGradient
                    id="paint1_radial_10877_58906"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(160.676 395.235) rotate(-43.7182) scale(263.015 120.42)"
                >
                    <stop stopColor="#B7E803" />
                    <stop offset="1" stopColor="#DAFF51" />
                </radialGradient>
                <clipPath id="clip0_10877_58906">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default renderAvatarSVG;
